import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetActiveSequenceMutationVariables = Types.Exact<{
  sequenceId: Types.Scalars['ID']['input'];
}>;


export type SetActiveSequenceMutation = { __typename?: 'Mutation', setActiveSequence?: boolean | null };


export const SetActiveSequence = /*#__PURE__*/ gql`
    mutation SetActiveSequence($sequenceId: ID!) {
  setActiveSequence(sequenceId: $sequenceId)
}
    ` as unknown as DocumentNode<SetActiveSequenceMutation, SetActiveSequenceMutationVariables>;

          

          export const useSetActiveSequenceMutation = (options?:MutationHookOptions<SetActiveSequenceMutation, SetActiveSequenceMutationVariables>) => useMutation(SetActiveSequence, options);
          

          export type SetActiveSequenceMutationOptions = MutationHookOptions<SetActiveSequenceMutation, SetActiveSequenceMutationVariables>;

          

          export type SetActiveSequenceMutationResult = ReturnType<typeof useSetActiveSequenceMutation>[1];

          
